// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * Copyright (c) 2023 by N-Ach (Pvt) Ltd
 *
 * ╔═╗ ╔╗    ╔═══╗  ╔╗
 * ║║╚╗║║    ║╔═╗║  ║║
 * ║╔╗╚╝║    ║║ ║╠══╣╚═╗
 * ║║╚╗║║╔══╗║╚═╝║╔═╣╔╗║
 * ║║ ║║║╚══╝║╔═╗║╚═╣║║║
 * ╚╝ ╚═╝    ╚╝ ╚╩══╩╝╚╝
 *
 * All rights reserved.
 *
 * This software is the confidential and proprietary information
 * of N-Ach (Pvt) Ltd. You shall not disclose such Confidential
 * Information and shall use it only in accordance with the terms
 * of the license agreement you entered into with N-Ach (Pvt) Ltd.
 *
 *
 * @Author Shalani Chethana
 * @Date 11/03/2025
 */

.services_videoCompOuterBox__XfP\\+O{
    width: 100%;
    height: 400px;
    overflow: hidden;
    position: relative;
    z-index: 0;
 }
.services_videoComp__1gfig{
    position: relative;
    width: 100vw;
    z-index: 1;
    /* height: 300px; */
}
.services_videoBackgroundBox__m0-YS{
    position: absolute;
    background-color: rgba(0, 0, 0, 0.508);
    color: #ffffff;
    z-index: 2;
    top: 200px;
    height: 100%;
    width: 100vw;
    padding: 50px 0px 50px 100px;
}
.services_videoBackgroundText__K9AH8{
    color: #ffffff;
    width: 50vw;
    
}


.services_outerContainerHeader__xUp-9{
    margin: 100px;
    align-items: left;
    text-align: left;
}

.services_titelUnderLine__1EcAw{
    height: 3px;
    width: 70px;
    border-radius: 3px;
    background-color:#077d92 ;
    margin: 20px 0px;
}
.services_titelFirsttxt__fQLGg{
    color:  #097ea8 ;
    letter-spacing: 2px;
    font-weight: 200;
}
.services_mainHeadertxt__AyUZ-{
    font-weight: 800;
    color: #1d1d1d;
}
.services_contentBodytxt__7I33u{
    margin-top: 30px;
}

@media (max-width:1024px){
    .services_videoBackgroundText__K9AH8{
        width: 70vw;
        
    }
    .services_outerContainerHeader__xUp-9{
        margin: 70px 50px;
    }

}

@media (max-width:770px){
    .services_videoCompOuterBox__XfP\\+O{
        height: 200px;
        
     }
     .services_videoBackgroundText__K9AH8{
        font-size: x-small;
        font-weight: 200;
     }
     .services_videoBackgroundBox__m0-YS{
        top: 50px;
        height: 100%;
        width: 100vw;
        padding: 20px 0px 20px 50px;
    }
    
}
@media (max-width:480px){
    .services_videoBackgroundBox__m0-YS{
        padding: 20px 0px 20px 20px;
    }
    .services_outerContainerHeader__xUp-9{
        margin: 50px 20px ;
    }
}



@media (max-width:1024px){
    
}
@media (max-width:770px){
    
}
@media (max-width:480px){
    
}`, "",{"version":3,"sources":["webpack://./src/pages/services.module.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;;;;;;EAoBE;;AAEF;IACI,WAAW;IACX,aAAa;IACb,gBAAgB;IAChB,kBAAkB;IAClB,UAAU;CACb;AACD;IACI,kBAAkB;IAClB,YAAY;IACZ,UAAU;IACV,mBAAmB;AACvB;AACA;IACI,kBAAkB;IAClB,sCAAsC;IACtC,cAAc;IACd,UAAU;IACV,UAAU;IACV,YAAY;IACZ,YAAY;IACZ,4BAA4B;AAChC;AACA;IACI,cAAc;IACd,WAAW;;AAEf;;;AAGA;IACI,aAAa;IACb,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,WAAW;IACX,kBAAkB;IAClB,yBAAyB;IACzB,gBAAgB;AACpB;AACA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;AACpB;AACA;IACI,gBAAgB;IAChB,cAAc;AAClB;AACA;IACI,gBAAgB;AACpB;;AAEA;IACI;QACI,WAAW;;IAEf;IACA;QACI,iBAAiB;IACrB;;AAEJ;;AAEA;IACI;QACI,aAAa;;KAEhB;KACA;QACG,kBAAkB;QAClB,gBAAgB;KACnB;KACA;QACG,SAAS;QACT,YAAY;QACZ,YAAY;QACZ,2BAA2B;IAC/B;;AAEJ;AACA;IACI;QACI,2BAA2B;IAC/B;IACA;QACI,kBAAkB;IACtB;AACJ;;;;AAIA;;AAEA;AACA;;AAEA;AACA;;AAEA","sourcesContent":["/*\r\n * Copyright (c) 2023 by N-Ach (Pvt) Ltd\r\n *\r\n * ╔═╗ ╔╗    ╔═══╗  ╔╗\r\n * ║║╚╗║║    ║╔═╗║  ║║\r\n * ║╔╗╚╝║    ║║ ║╠══╣╚═╗\r\n * ║║╚╗║║╔══╗║╚═╝║╔═╣╔╗║\r\n * ║║ ║║║╚══╝║╔═╗║╚═╣║║║\r\n * ╚╝ ╚═╝    ╚╝ ╚╩══╩╝╚╝\r\n *\r\n * All rights reserved.\r\n *\r\n * This software is the confidential and proprietary information\r\n * of N-Ach (Pvt) Ltd. You shall not disclose such Confidential\r\n * Information and shall use it only in accordance with the terms\r\n * of the license agreement you entered into with N-Ach (Pvt) Ltd.\r\n *\r\n *\r\n * @Author Shalani Chethana\r\n * @Date 11/03/2025\r\n */\r\n\r\n.videoCompOuterBox{\r\n    width: 100%;\r\n    height: 400px;\r\n    overflow: hidden;\r\n    position: relative;\r\n    z-index: 0;\r\n }\r\n.videoComp{\r\n    position: relative;\r\n    width: 100vw;\r\n    z-index: 1;\r\n    /* height: 300px; */\r\n}\r\n.videoBackgroundBox{\r\n    position: absolute;\r\n    background-color: rgba(0, 0, 0, 0.508);\r\n    color: #ffffff;\r\n    z-index: 2;\r\n    top: 200px;\r\n    height: 100%;\r\n    width: 100vw;\r\n    padding: 50px 0px 50px 100px;\r\n}\r\n.videoBackgroundText{\r\n    color: #ffffff;\r\n    width: 50vw;\r\n    \r\n}\r\n\r\n\r\n.outerContainerHeader{\r\n    margin: 100px;\r\n    align-items: left;\r\n    text-align: left;\r\n}\r\n\r\n.titelUnderLine{\r\n    height: 3px;\r\n    width: 70px;\r\n    border-radius: 3px;\r\n    background-color:#077d92 ;\r\n    margin: 20px 0px;\r\n}\r\n.titelFirsttxt{\r\n    color:  #097ea8 ;\r\n    letter-spacing: 2px;\r\n    font-weight: 200;\r\n}\r\n.mainHeadertxt{\r\n    font-weight: 800;\r\n    color: #1d1d1d;\r\n}\r\n.contentBodytxt{\r\n    margin-top: 30px;\r\n}\r\n\r\n@media (max-width:1024px){\r\n    .videoBackgroundText{\r\n        width: 70vw;\r\n        \r\n    }\r\n    .outerContainerHeader{\r\n        margin: 70px 50px;\r\n    }\r\n\r\n}\r\n\r\n@media (max-width:770px){\r\n    .videoCompOuterBox{\r\n        height: 200px;\r\n        \r\n     }\r\n     .videoBackgroundText{\r\n        font-size: x-small;\r\n        font-weight: 200;\r\n     }\r\n     .videoBackgroundBox{\r\n        top: 50px;\r\n        height: 100%;\r\n        width: 100vw;\r\n        padding: 20px 0px 20px 50px;\r\n    }\r\n    \r\n}\r\n@media (max-width:480px){\r\n    .videoBackgroundBox{\r\n        padding: 20px 0px 20px 20px;\r\n    }\r\n    .outerContainerHeader{\r\n        margin: 50px 20px ;\r\n    }\r\n}\r\n\r\n\r\n\r\n@media (max-width:1024px){\r\n    \r\n}\r\n@media (max-width:770px){\r\n    \r\n}\r\n@media (max-width:480px){\r\n    \r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"videoCompOuterBox": `services_videoCompOuterBox__XfP+O`,
	"videoComp": `services_videoComp__1gfig`,
	"videoBackgroundBox": `services_videoBackgroundBox__m0-YS`,
	"videoBackgroundText": `services_videoBackgroundText__K9AH8`,
	"outerContainerHeader": `services_outerContainerHeader__xUp-9`,
	"titelUnderLine": `services_titelUnderLine__1EcAw`,
	"titelFirsttxt": `services_titelFirsttxt__fQLGg`,
	"mainHeadertxt": `services_mainHeadertxt__AyUZ-`,
	"contentBodytxt": `services_contentBodytxt__7I33u`
};
export default ___CSS_LOADER_EXPORT___;
